import { inject, Injectable } from '@angular/core';
import { LookupsApiService } from '../services/lookups-api.service';
import { Constants } from 'common';
import { defer, map } from 'rxjs';
import { RoleService } from '../services/role.service';

@Injectable({
  providedIn: 'root',
})
export class SignupLookupsResolver {
  lookupsService = inject(LookupsApiService);
  roleService = inject(RoleService);

  resolve() {
    return defer(() => {
      if (this.roleService.hasNoRole || this.roleService.isSido || this.roleService.isPaOrMsp ) {
        return this.lookupsService.getSignUpOrPaMspLookups$().pipe(
          map(({ value: { country, organisationType, accountTypeExternal } }) => ({
            country, organisationType, accountType: accountTypeExternal,
          })),
        );
      }

      if (this.roleService.isAdmin || this.roleService.isRtp) {
        return this.lookupsService.getAdminLookups$().pipe(
          map(({ value: { country, organisationType, accountType } }) => ({
            country, organisationType, accountType,
          })),
        );
      }

    }).pipe(
      map(({ country, organisationType, accountType }) => ({
        countries: country
          .sort((a, b) => {
            if (a === Constants.irelandCountryString && b === Constants.irelandCountryString) return 0;
            if (a === Constants.irelandCountryString) return -1;
            return 1;
          })
          .map((value) => ({ key: value, value: value, type: value })),
        organisationTypes: organisationType.map(({ displayName, value }) => ({ key: displayName, value, type: displayName })),
        accountTypes: accountType.map(({ displayName, value }) => ({ key: displayName, value: value, type: displayName })),
      }))
    );
  }
}
